<template>
  <div class="entry-list">
    <van-tabs v-model="role" @change="onClick">
      <van-tab title="队伍报名表" :name="1"></van-tab>
      <van-tab title="个人参赛表" :name="0"></van-tab>
    </van-tabs>

    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="teams" v-if="teams.length > 0">
        <div v-if="role === 1">
          <div class="item team-item" v-for="item in teams" :key="item.id" @click="goEntryInfo(item)">
            <div class="item-row">
              <div class="item-left">
                <img
                  :src="imageView(item.badge || match.icon)"
                  class="team-logo"
                  alt=""
                >
              </div>
              <div class="item-mid">
                <div class="mid-line1 overflow-text">{{ item.name }}</div>
                <div class="mid-line2 overflow-text">{{ getPartByIndex(item.chineseName, 1) }}</div>
              </div>
              <div class="item-right">
                <span v-if="item.isSubmit === 0" class="status-text status-text--muted">未提交</span>
                <span v-else-if="item.auditStatus === 0 || item.auditStatus === 1" class="status-text status-text--pending">待确认</span>
                <span v-else-if="item.auditStatus === 3" class="status-text status-text--success">已锁定</span>
                <span v-else-if="item.auditStatus === 2" class="status-text status-text--success">已确认</span>
                <span v-else-if="item.auditStatus === -1" class="status-text status-text--danger">已退回</span>
              </div>
            </div>
            <div v-if="item.auditStatus === -1 && item.auditRemark" class="bottom">
              退回理由：{{ item.auditRemark }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="item player-item" v-for="item in teams" :key="item.id" @click="goPlayerInfo(item)">
            <div class="item-row">
              <div class="item-left" v-if="item.avatar">
                <img
                  :src="imageView(item.avatar)"
                  class="team-logo"
                  alt=""
                >
              </div>
              <div class="item-mid">
                <div class="mid-line1 overflow-text">{{ item.trueName }}</div>
                <div class="mid-line2 overflow-text">{{ item.name }}</div>
              </div>
              <div class="item-right item-right--stack">
                <div>
                  <span v-if="item.isSubmit === 0" class="status-text status-text--muted">未提交</span>
                  <span v-else-if="item.auditStatus === 0 || item.auditStatus === 1" class="status-text status-text--pending">待确认</span>
                  <span v-else-if="item.auditStatus === 3" class="status-text status-text--success">已锁定</span>
                  <span v-else-if="item.auditStatus === 2" class="status-text status-text--success">已确认</span>
                  <span v-else-if="item.auditStatus === -1" class="status-text status-text--danger">已退回</span>
                </div>
                <div class="pay-info" v-if="item.isOpenCharge === 1 && item.feeMethod === 1 && item.orderStatus !== 1 && item.orderStatus !== 2">
                  <div class="pay" @click.stop="doPay(item)">付 款</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无报名" />
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabs, Tab, Dialog, Empty, PullRefresh, Toast } from 'vant'
Vue.use(Tabs).use(Tab).use(Dialog).use(Empty).use(PullRefresh).use(Toast)
import { getBMUnionMatch,getMatchTeamListByUser,getBMMatchOrderListByUser,bangsaishiCreatePlayerSignupOrder,bangsaishiCreateTeamSignupOrder } from '@/api/match'
import { QNImageUtil } from '@/utils'
import { getPassport } from "@/libs/passport";

export default {
  data() {
    return {
      unionMatchId: '',
      accountId: '',
      match: {},
      teams: [],
      isLoading: false,
      orderIndex: 0,
      role: 1
    };
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        const role = this.$route.query.role || 1
        this.role = Number(role)
        this.unionMatchId = this.$route.params.unionMatchId || ''
        this.accountId = this.$route.query.accountId || ''
        if (this.unionMatchId) {
          this.getBMUnionMatch()
          this.getMatchTeamListByUser()
          this.getBMMatchOrderListByUser()
        } else if (this.accountId) {
          this.getMatchTeamListByUser()
          this.getBMMatchOrderListByUser()
        }
      }
    })
  },
  methods: {
    getBMUnionMatch() {
      if (!this.unionMatchId) return
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          document.title = data.match.chineseName
          const shareObj = {
            title: this.match.chineseName,
            abstract: '我的报名',
            image: QNImageUtil.imageView(this.match.icon)
          }
          this.wxShare(shareObj)
        }
      })
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getMatchTeamListByUser() {
      const params = {
        role: this.role,
        orderIndex: this.orderIndex
      }
      if (this.unionMatchId) {
        params.unionMatchId = this.unionMatchId
      } else if (this.accountId) {
        params.accountId = this.accountId
      } else {
        params.unionMatchId = this.unionMatchId
      }
      getMatchTeamListByUser(params).then(res => {
        if (res) {
          const data = res.data
          this.teams = data.list
          this.isLoading = false
          const user = data.user || {}
          if (!user.mobile) {
            Dialog.alert({
              title: '您还没有关联手机号',
              message: '关联手机号后，可查看电子参赛证，获取看更多赛事信息',
            }).then(() => {
              this.$router.push('/entry-page/correlate-mobile')
            })
          }
        }
      })
    },
    getBMMatchOrderListByUser() {
      const params = {}
      if (this.unionMatchId) {
        params.unionMatchId = this.unionMatchId
      } else if (this.accountId) {
        params.accountId = this.accountId
      } else {
        params.unionMatchId = this.unionMatchId
      }
      getBMMatchOrderListByUser(params).then(res => {
        if (res) {
          const data = res.data
          const list = data.list || []
          const l = list.find(item => item.orderStatus === 0)
          console.log(l);
          
          if (l) {
            Dialog.confirm({
              title: '尚未支付',
              message: '有订单尚未支付',
              cancelButtonText: '我再想想',
              confirmButtonText: '前往支付'
            }).then(() => {
              const category = l.feeMethod === 1 ? 1 : 0
              const q = this.scopedQuery(l, `orderId=${l.orderId}&category=${category}&matchId=${l.matchId}&teamId=${l.teamId}`)
              this.$router.push(`/entry-page/payment?${q}`)
            })
          }
        }
      })
    },
    onClick() {
      this.getMatchTeamListByUser()
    },
    onRefresh() {
      this.getMatchTeamListByUser()
    },
    /**
     * 列表项 / 订单行上的 unionMatchId 由接口返回；机构入口进页时路由可能没有 unionMatchId，跳转子页仍需带上每条数据的 unionMatchId。
     * 机构维度保留 accountId，便于返回「机构下全部报名」列表。
     */
    listScopeQuery(row) {
      const qs = []
      const unionId = (row && row.unionMatchId) || this.unionMatchId
      if (unionId) {
        qs.push(`unionMatchId=${unionId}`)
      }
      if (this.accountId) {
        qs.push(`accountId=${this.accountId}`)
      }
      return qs.join('&')
    },
    /** listScopeQuery 可能为空，与后续参数拼接时避免 ?& 或 && */
    scopedQuery(row, restQuery) {
      const scope = this.listScopeQuery(row)
      return scope ? `${scope}&${restQuery}` : restQuery
    },
    goEntryInfo(item) {
      const q = this.scopedQuery(item, `matchId=${item.matchId}&teamId=${item.teamId}`)
      if (item.unitType === 1) {
        this.$router.push(`/entry-page/person-info?${q}`)
      } else {
        this.$router.push(`/entry-page/entry-info?${q}`)
      }
    },
    goPlayerInfo(item) {
      const q = this.scopedQuery(item, `matchId=${item.matchId}&teamId=${item.teamId}&playerId=${item.playerId}`)
      this.$router.push(`/entry-page/entry-info-player?${q}`)
    },
     getPartByIndex(s, i) {
      if (!s) return ''
      const arr = s.split('_')
      if (arr.length > i) return arr[i]
      return ''
    },
    doPay(item) {
      const regEndDate = this.match.regEndDate || ''
      const regUpdateEndDate = this.match.regUpdateEndDate || ''
      if (regEndDate && regUpdateEndDate) {
        if (new Date().getTime() > new Date(regEndDate).getTime() && new Date().getTime() > new Date(regUpdateEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      } else if (regEndDate) {
        if (new Date().getTime() > new Date(regEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      } else if (regUpdateEndDate) {
        if (new Date().getTime() > new Date(regUpdateEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      }
      const params = {
        matchId: item.matchId,
        teamId: item.teamId
      }
      if (item.role === 0) {
        params.playerId = item.playerId
        bangsaishiCreatePlayerSignupOrder(params).then(res => {
          if (res) {
            const q = this.scopedQuery(item, `orderId=${res.data.orderId}&category=1&matchId=${item.matchId}&teamId=${item.teamId}&playerId=${item.playerId}`)
            this.$router.push(`/entry-page/payment?${q}`)
          }
        })
      } else if (item.role === 1) {
        bangsaishiCreateTeamSignupOrder(params).then(res => {
          if (res) {
            const q = this.scopedQuery(item, `orderId=${res.data.orderId}&category=0&matchId=${item.matchId}&teamId=${item.teamId}`)
            this.$router.push(`/entry-page/payment?${q}`)
          }
        })
      }

    },
  },
};
</script>

<style scoped lang="scss">
.entry-list {
  background-color: #FFF;
  border-radius: 4px 4px 8px 8px;
  margin-bottom: 24px;
  min-height: 100vh;
  box-sizing: border-box;
  .teams {
    padding: 0 12px 12px;
    .item {
      border-radius: 5px;
      background: #F9F9F9;
      margin-top: 12px;
      padding: 12px;
      box-sizing: border-box;
    }
    .item-row {
      display: flex;
      align-items: center;

      > * + * {
        margin-left: 10px;
      }
    }
    .item-left {
      flex-shrink: 0;
    }
    .team-logo {
      width: 45px;
      height: 45px;
      border-radius: 3px;
      object-fit: cover;
      display: block;
      background: #EBEEF5;
      &--empty {
        box-sizing: border-box;
      }
    }
    .item-mid {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;

      > * + * {
        margin-top: 4px;
      }
    }
    .mid-line1 {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      line-height: 20px;
    }
    .mid-line2 {
      font-size: 12px;
      color: #909399;
      line-height: 16px;
    }
    .item-right {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      &--stack {
        flex-direction: column;
        align-items: flex-end;

        > * + * {
          margin-top: 8px;
        }
      }
    }
    .status-text {
      font-size: 12px;
      line-height: 18px;
      white-space: nowrap;
      &--muted {
        color: #73767A;
      }
      &--pending {
        color: #E6A23C;
      }
      &--success {
        color: #529B2E;
      }
      &--danger {
        color: #C45656;
      }
    }
    .bottom {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid #F0F0F0;
      font-size: 12px;
      color: #C45656;
      line-height: 18px;
    }
    .pay-info {
      .pay {
        font-size: 12px;
        color: #337ECC;
        padding: 4px 10px;
        border: 1px solid #337ECC;
        border-radius: 3px;
        line-height: 1;
      }
    }
  }
}
</style>
